const getAlignContentSize = (alignContent = 'center') => ({
  justifyContent: alignContent === 'center' ? 'center' : 'flex-start'
});

export { getAlignContentSize };
